export const MOVE = 'move' as const;
export const DELETE = 'delete' as const;
